// extracted by mini-css-extract-plugin
export default {"section-tabs":"section-tabs_section-tabs__9sDFr"};